import React from 'react';
import '../styles/landing.css';
import '../styles/landing-stages.css';
import '../styles/landing-mobile-readable.css';
import ConciseLandingPage from './ConciseLandingPage';
import LandingSurvey from '../components/feedback/LandingSurvey';

export default function LandingPage() {
  return <><ConciseLandingPage /><LandingSurvey /></>;
}
